// IANA time zones for the club time zone picker. Drives when the weekly
// membership-expiry digest is sent (Monday 8am club time).
const FALLBACK_ZONES = [
  "Pacific/Auckland", "Pacific/Chatham", "Australia/Sydney", "Australia/Melbourne",
  "Australia/Brisbane", "Australia/Adelaide", "Australia/Darwin", "Australia/Perth",
  "Australia/Hobart", "Pacific/Fiji", "Asia/Tokyo", "Asia/Singapore", "Asia/Hong_Kong",
  "Europe/London", "Europe/Berlin", "America/New_York", "America/Chicago",
  "America/Denver", "America/Los_Angeles", "UTC",
];

export const DEFAULT_TIMEZONE = "Pacific/Auckland";

export function listTimezones() {
  try {
    if (typeof Intl.supportedValuesOf === "function") {
      const zones = Intl.supportedValuesOf("timeZone");
      if (zones.length) return zones.includes("UTC") ? zones : [...zones, "UTC"];
    }
  } catch (e) {
    // older browsers — fall through
  }
  return FALLBACK_ZONES;
}

export function browserTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || DEFAULT_TIMEZONE;
  } catch (e) {
    return DEFAULT_TIMEZONE;
  }
}
